import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullAlertComponent } from './full-alert.component';

@NgModule({
  declarations: [FullAlertComponent],
  imports: [
    CommonModule
  ],
  exports: [FullAlertComponent]
})
export class FullAlertModule { }
